import { render, staticRenderFns } from "./LoanDetail.vue?vue&type=template&id=ab0c3b0e&"
import script from "./LoanDetail.vue?vue&type=script&lang=js&"
export * from "./LoanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports